<template>
    <div class="nav">
        <div class="nav-head">
            <div class="app">
                <img class="appAvatar" :src="this.$store.state.user.appAvatar" alt />

                <div class="nav-btn" @click="hiddenNavMethods">
                    <i v-if="!$store.state.hiddenNav" class="el-icon-d-arrow-left"></i>
                    <i v-else class="el-icon-d-arrow-right"></i>
                </div>
            </div>
            <div class="history-con">
                <history></history>
            </div>
            <div class="userCon">
                <el-dropdown @command="clickDropdown">
                    <span class="el-dropdown-link">
                        <div class="user">
                            <img class="avatar" :src="this.$store.state.user.avatar" alt />
                            <div class="name">{{this.$store.state.user.name}}</div>
                        </div>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="openPersonal">个人中心</el-dropdown-item>
                        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="list" :class="{'hidden-nav-list':$store.state.hiddenNav}">
            <vue-scroll :ops="ops2">
                <div
                    v-if="show(item.role)  && (item.nav != 'chat' || $store.state.user.chatPrivate)"
                    class="con"
                    v-for="(item,index) in this.$store.state.navigationList"
                    :key="index + 'super'"
                >
                    <!--  -->
                    <div
                        class="item super"
                        @click="clickSuper(item,index)"
                        :class="{actSuper : $route.meta.nav == item.nav}"
                    >
                        <i class="icon" :class="item.icon"></i>
                        <span style="margin-left:8px;">{{item.text}}</span>
                        <div class="unfold" v-if="item.child && item.child.length > 0">
                            <i v-if="item.open" class="el-icon-arrow-up"></i>
                            <i v-else class="el-icon-arrow-down"></i>
                        </div>
                    </div>
                    <!-- 子菜单 -->
                    <div
                        v-if="item.open && show(childItem.role)"
                        class="item child"
                        v-for="(childItem,childIndex) in item.child"
                        :key="childIndex + 'child'"
                        @click="clickChild(childItem,childIndex)"
                        :class="{actChild : $route.meta.navChild == childItem.nav}"
                    >
                        <span>{{childItem.text}}</span>
                    </div>
                </div>
            </vue-scroll>
        </div>

        <!-- 个人中心 -->
        <el-dialog
            title="个人中心"
            :visible.sync="showPersonal"
            :before-close="closePersonal"
            class="personal-dialog"
            :close-on-click-modal="false"
        >
            <vue-scroll :ops="ops2">
                <div class="personal-dialog-con">
                    <!-- 头像 -->
                    <div class="personal-dialog-item">
                        <img class="img" :src="info.avatar" alt />
                        <div class="personal-dialog-item-name-con">
                            <div class="personal-dialog-item-name">{{info.name}}</div>
                            <div
                                style="margin-top:8px;"
                                class="personal-dialog-item-name"
                            >{{info.account}}</div>
                        </div>
                    </div>
                    <!--  -->
                    <div class="personal-dialog-item" style="padding-top:2px;">
                        <div
                            class="personal-dialog-item-left"
                            style="height:22px;line-height:22px;margin-top:8px;"
                        >
                            <span>客服组：</span>
                        </div>

                        <div
                            style="margin-top:8px;color:#fff;float:left;background:#409EFF;width:70px;text-align: center;height:22px;line-height:22px;margin-left:10px;"
                            v-for="(item,index) in info.userGroup"
                            :key="index"
                        >
                            <span>{{item.name}}</span>
                        </div>
                    </div>
                    <!--  -->
                    <div class="personal-dialog-item no-border">
                        <div class="personal-dialog-item-left">
                            <span>角色：</span>
                        </div>
                        <div class="personal-dialog-item-right">
                            <span v-if="info.myRole == 'admin'">超级管理员</span>
                            <span v-if="info.myRole == 'manager'">在线管理员</span>
                            <span v-if="info.myRole == 'service'">在线客服</span>
                        </div>
                    </div>
                    <!--  -->
                    <div style="margin-top:8px;" class="personal-dialog-set-item">
                        <div class="personal-dialog-set-title">
                            <span>个人配置</span>
                        </div>
                        <div style="padding-top:8px;overflow: hidden;">
                            <span style="float:left;">通过公众号接受客服消息推送提醒：</span>
                            <div style="float:right;">
                                <span style="vertical-align: middle;" v-if="info.receiveNotice">已开启</span>
                                <span style="vertical-align: middle;" v-else>已关闭</span>
                                <el-switch
                                    :disabled="!info.appNoticeOpen"
                                    @change="setCenter"
                                    style="vertical-align: middle;margin-left:5px;"
                                    v-model="info.receiveNotice"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                ></el-switch>
                            </div>
                        </div>
                        <div style="margin-top:8px;color:#999;">开启消息推送服务后，您将通过服务号接收到相关的客服消息提醒</div>
                        <div style="padding-top:8px;overflow: hidden;">
                            <span style="float:left;">桌面新消息提醒：</span>
                            <div style="float:right;">
                                <span style="vertical-align: middle;" v-if="info.receiveWebsocketNotify">已开启</span>
                                <span style="vertical-align: middle;" v-else>已关闭</span>
                                <el-switch
                                    @change="setWs"
                                    style="vertical-align: middle;margin-left:5px;"
                                    v-model="info.receiveWebsocketNotify"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                ></el-switch>
                            </div>
                        </div>
                        <div style="margin-top:8px;color:#999;">开启新消息提醒后，新消息以桌面通知的方式进行提醒</div>
                    </div>
                    <!--  -->
                    <div style="margin-top:8px;" class="personal-dialog-item">
                        <div class="personal-dialog-item-left">
                            <span>姓名：</span>
                        </div>
                        <div class="personal-dialog-item-right">
                            <span>{{info.userName}}</span>
                        </div>
                    </div>
                    <!--  -->
                    <div class="personal-dialog-item no-border">
                        <div class="personal-dialog-item-left">
                            <span>手机号：</span>
                        </div>
                        <div class="personal-dialog-item-right">
                            <span>{{info.mobile}}</span>
                        </div>
                    </div>

                    <div style="height:100px;"></div>
                </div>
            </vue-scroll>
        </el-dialog>
    </div>
</template>
<script>
import history from "./history.vue";

export default {
    data() {
        return {
            ops: {
                vuescroll: {
                    mode: "native"
                },
                sizeStrategy: "number",
                scrollPanel: {
                    // 是否允许x或y方向上的滚动
                    scrollingX: false,
                    scrollingY: true
                },
                scrollContent: {},
                vRail: {}
            },
            ops2: {
                vuescroll: {
                    mode: "native"
                },
                sizeStrategy: "number",
                scrollPanel: {
                    // 是否禁止x或y方向上的滚动
                    scrollingX: false,
                    scrollingY: true
                },
                scrollContent: {},
                vRail: {}
            },

            showPersonal: false,
            info: {}
        };
    },
    components: {
        history
    },
    methods: {
        hiddenNavMethods() {
            this.$store.state.hiddenNav = !this.$store.state.hiddenNav;
        },

        //
        openPersonal() {
            this.getInfo();

            this.showPersonal = true;
        },
        closePersonal() {
            this.showPersonal = false;
        },
        getInfo() {
            this.$reqPost("/api/userInfo/get", {}).then(
                res => {
                    this.info = res.data.returnData;
                },
                err => {}
            );
        },
        setCenter() {
            this.$reqPost("/api/user/center/put", {}).then(
                res => {
                    this.info = res.data.returnData;

                    this.$message({
                        message: "修改成功!",
                        type: "success"
                    });
                },
                err => {
                    this.getInfo();
                }
            );
        },
        setWs() {
            this.$reqPost("/api/user/center/ws/put", {}).then(
                res => {
                    this.info = res.data.returnData;
                    this.$store.state.user.receiveWebsocketNotify = res.data.returnData.receiveWebsocketNotify;

                    this.$message({
                        message: "修改成功!",
                        type: "success"
                    });
                },
                err => {
                    this.getInfo();
                }
            );
        },
        // 判断是否显示,当前菜单所需角色
        show(role) {
            // 如果不需要权限
            if (!role || role.length == 0) {
                return true;
            }
            // 如果需要权限  则判断有没有所需的权限
            if (this.roleIsContained(this.$store.state.user.myRole, role)) {
                return true;
            } else {
                return false;
            }
        },
        // 判断a数组中是否有b数组的数据
        isHave(a, b) {
            // 遍历b数组  如果有相同  则返回true
            for (let i = 0; i < b.length; i++) {
                for (let j = 0; j < a.length; j++) {
                    if (b[i] == a[j]) {
                        return true;
                    }
                }
            }
            return false;
        },
        roleIsContained(myrole, roles){
            if(roles.indexOf(myrole)==-1){
                return false;
            }
            return true;
        },
        // 判断b数组是否包含在a数组中
        isContained(a, b) {
            if (!(a instanceof Array) || !(b instanceof Array)) return false;
            if (a.length < b.length) return false;
            var aStr = a.toString();
            for (var i = 0, len = b.length; i < len; i++) {
                if (aStr.indexOf(b[i]) == -1) return false;
            }
            return true;
        },
        clickSuper(item, index) {
            // 判断有没有子菜单  有 则展开
            if (item.child && item.child.length > 0) {
                let obj = this.$store.state.navigationList[index];
                obj.open = !obj.open;
                this.$set(this.$store.state.navigationList, index, obj);
            }
            //
            if (item.router) {
                this.$clearHistory();
                this.$router.replace(item.router);
            }
        },
        clickChild(item) {
            if (!item.router) {
                return;
            }
            this.$clearHistory();
            this.$router.replace(item.router);
        },
        clickDropdown(e) {
            this[e]();
        },
        logout() {
            // 清除本地
            this.$reqPost("/api/logout", {}).then(
                res => {
                    this.$message({
                        message: "您已退出登录"
                    });

                    localStorage.removeItem("sessionId");

                    location.reload();
                },
                err => {}
            );
        }
    },
    mounted() {}
};
</script>

<style lang="scss" scoped>
.nav {
    -webkit-touch-callout: none; /*系统默认菜单被禁用*/
    -webkit-user-select: none; /*webkit浏览器*/
    -khtml-user-select: none; /*早期浏览器*/
    -moz-user-select: none; /*火狐*/
    -ms-user-select: none; /*IE10*/
    user-select: none;
}
.nav-head {
    height: 50px;
    width: 100vw;
    position: absolute;
    top: 0;
    background: #000;
    z-index: 99;
    .history-con {
        position: absolute;
        width: calc(100vw - 140px - 260px);
        height: 100%;
        left: 140px;
        top: 0;
    }
}
.list {
    color: #cacaca;
    width: 190px;
    height: 100vh;
    position: absolute;
    left: 0;
    background: #313a4e;
    padding-top: 50px;
    .con {
        .item {
            width: 190px;
            height: 50px;
            line-height: 50px;
            padding: 0 8px;
            cursor: pointer;
        }
        .super {
            position: relative;
            border-bottom: 1px solid #313a4e;
            padding-left: 30px;
            background: #3d4961;
            color: #b0b3bb;
            .icon {
                font-size: 16px;
            }
            .unfold {
                position: absolute;
                font-size: 20px;
                right: 8px;
                top: 0;
            }
        }
        .super:hover {
            color: #1ba8ed;
        }
        .actSuper {
            background: #e6eaf2;
            color: #1a1a1a;
        }
        .actSuper:hover {
            background: #e6eaf2;
            color: #1a1a1a;
        }

        .child {
            padding-left: 58px;
            background: #313a4e;
            color: #8d8e93;
        }
        .child:hover {
            color: #1ba8ed;
        }
        .actChild {
            color: #fff;
            background: #2b3345;
        }
        .actChild:hover {
            color: #fff;
        }
    }
}
.hidden-nav-list {
    width: 0;
}

.app {
    position: absolute;
    top: 0;
    left: 0;
    .appAvatar {
        width: 40px;
        height: 40px;
        margin-top: 5px;
        margin-left: 12px;
        float: left;
    }
    .nav-btn {
        cursor: pointer;
        float: left;
        background: #000;
        color: #eee;
        border: 2px solid #ccc;
        height: 20px;
        line-height: 20px;
        margin-top: 25px;
        width: 40px;
        font-size: 14px;
        text-align: center;
        border-radius: 5px;
        margin-left: 30px;
    }
}

.userCon {
    position: absolute;
    right: 8px;
    top: 0;
}
.user {
    height: 50px;
    line-height: 50px;
    overflow: hidden;
    text-align: center;
    overflow: hidden;
    cursor: pointer;
    .avatar {
        width: 35px;
        height: 35px;
        float: left;
        margin: 7.5px 5px 0;
        border-radius: 50%;
    }
    .name {
        height: 50px;
        color: #cacaca;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding: 0 5px;
        float: left;
    }
}
</style>
<style lang="scss">
.personal-dialog .el-dialog {
    width: 500px;
    height: 90vh;
    overflow: hidden;
    margin-top: 5vh !important;
    margin-bottom: 5vh !important;
    .el-dialog__body {
        padding: 0 20px;
        height: calc(100% - 54px);
        .__vuescroll {
            border: 1px solid #ddd;
            background-color: rgb(242, 242, 242);
            height: calc(100% - 8px) !important;
        }
        .personal-dialog-con {
            font-size: 14px;
            .personal-dialog-item {
                background: #fff;
                border-bottom: 1px solid #ddd;
                padding: 10px;
                overflow: hidden;
                .img {
                    width: 50px;
                    height: 50px;
                    display: block;
                    float: left;
                }
                .personal-dialog-item-name-con {
                    float: left;
                    padding: 7px 10px;
                }
                .personal-dialog-item-left {
                    float: left;
                }
                .personal-dialog-item-right {
                    float: right;
                }
            }
            .no-border {
                border-bottom: none;
            }
            .personal-dialog-set-item {
                background: #fff;
                padding: 10px;
                .personal-dialog-set-title {
                    font-size: 16px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 8px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/vue/components/nav2.vue